export default "__VITE_ASSET__D8zg65TZ__"